import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cva } from 'class-variance-authority';
import React from 'react';
import { Drawer } from 'vaul';
import { BrandSquareMono } from '~/brand/BrandContext';

export type SidesheetProps = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  subnav?: boolean;
};

const sideSheetStyles = cva('h-screen overflow-auto shadow-lg', {
  variants: {
    subnav: {
      true: 'bg-primary-container text-white flex flex-col pb-6',
      false: 'bg-white',
    },
  },
  defaultVariants: {
    subnav: false,
  },
});

export const SideSheet = ({
  children,
  isOpen,
  onClose,
  title,
  subnav = false,
}: SidesheetProps) => {
  return (
    <Drawer.Root
      direction='left'
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <Drawer.Portal>
        {/* Backdrop */}
        <Drawer.Overlay className='fixed inset-0 z-[100] bg-black/40' />

        {/* Content anchored to left with a 40px gap on the right */}
        <Drawer.Content className='fixed inset-y-0 left-0 z-[1300] w-11/12 outline-none '>
          <div className='h-screen w-full overflow-clip rounded-br-3xl rounded-tr-3xl'>
            <div className={sideSheetStyles({ subnav })}>
              <div className='flex items-center justify-between p-4 pb-7 pr-6'>
                {title ? (
                  <div className='text-xl font-medium'>{title}</div>
                ) : (
                  <BrandSquareMono className='h-10 w-10' />
                )}
                <button type='button' onClick={onClose} className='text-white'>
                  <FontAwesomeIcon icon={faXmark} className='h-6 w-6' />
                </button>
              </div>
              {children}
            </div>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};
